module.exports = __webpack_public_path__ + "img/tn-stock-4.d5bed6f1.jpeg";